import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { getDefaultWorkspaceHref } from '@/features/Commons/Sidebar/model/sidebar-schema';

const DetailRedirection = () => {
  const navigate = useNavigate();
  const { workspace_id } = useParams();

  useEffect(() => {
    if (!workspace_id) {
      navigate('/', { replace: true });
    } else {
      navigate(`/workspace/${workspace_id}${getDefaultWorkspaceHref()}`, {
        replace: true,
      });
    }
  }, [navigate, workspace_id]);

  return null;
};

export default DetailRedirection;
